import { render, staticRenderFns } from "./Bubble.vue?vue&type=template&id=7ba3c6bc&scoped=true"
import script from "./Bubble.vue?vue&type=script&lang=js"
export * from "./Bubble.vue?vue&type=script&lang=js"
import style0 from "./Bubble.vue?vue&type=style&index=0&id=7ba3c6bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba3c6bc",
  null
  
)

export default component.exports